import { StyleSheet, Text } from '@react-pdf/renderer';
import React from 'react';

import { CarrierFactory } from '../../../../../../common/carrierConfig/carrierFactory';
import { Carriers } from '../../../../../../common/constants/carriers';

export interface ReinstatementApprovalContentProps {
  carrier: Carriers;
}

const ReinstatementApprovalContent = ({
  carrier,
}: ReinstatementApprovalContentProps) => (
  <>
    <Text style={styles.text}>
      Thank you for applying for life insurance with{' '}
      {CarrierFactory.getCarrierConfig(carrier)?.getCarrierDisplayName()}. Your
      application is appreciated.
    </Text>
    <Text style={styles.text}>
      The underwriting of your reinstatement request has been completed. We are
      pleased to inform you that we have approved your request and your policy
      can be reinstated.
    </Text>
    <Text style={styles.text}>
      To reinstate your policy, all past-due payments must be satisfied in order
      to bring your premium balance up-to-date. An email will be sent to you
      with further instructions on how to make your payment and finalize the
      reinstatement of your policy.
    </Text>
  </>
);

const styles = StyleSheet.create({
  text: {
    fontSize: 10,
    lineHeight: 1.4,
    marginBottom: 12,
  },
  bold: {
    fontWeight: '700',
  },
});

export default ReinstatementApprovalContent;
